import { MeetingResponse } from 'lib/api/meetings/types';
import { pushToDataLayer } from '../../pushToDataLayer';
import {
  mapToGTMMeetingAttributes,
  transformMeetingResponseToGTMAttributes,
} from './utils';
import { GTMEvent, GTMEventAttributes, GTMEventName } from '../../types';
import { CreateMeetingEventType, GTMMeetingAttributes } from './types';

export function createMeetingEvent({
  meetingResponse,
  livePageUrl,
  attendeeLimit,
  type,
}: {
  meetingResponse?: MeetingResponse;
  livePageUrl?: string;
  attendeeLimit?: number;
  type: CreateMeetingEventType;
}) {
  const eventAttributes: GTMEventAttributes = {
    event: GTMEvent.COVIDEO_EVENT,
    event_name: GTMEventName.CREATE_NEW_MEETING,
  };
  const meetingAttributes = transformMeetingResponseToGTMAttributes(
    meetingResponse,
    livePageUrl,
    attendeeLimit
  );

  const gtmMeetingAttributes: GTMMeetingAttributes =
    mapToGTMMeetingAttributes(meetingAttributes);

  pushToDataLayer({
    ...eventAttributes,
    type: type,
    ...gtmMeetingAttributes,
  });
}
